import React, { useContext } from 'react'
import { Container, Stack, Box, Typography, Button } from "@mui/material"
import firebaseConfig from "../firebase";
import { useState, useEffect } from "react";
import { collection, getDocs, } from "firebase/firestore";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js'
import { Pie } from "react-chartjs-2";
import { getFirestore } from 'firebase/firestore';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {useAuth} from '../contexts/AuthContext'

function Dashboard() {
    const [error, setError] = useState("")
    const { currentUser, logout } = useAuth()
    const Navigate = useNavigate()

    async function handleLogout() {
      setError("")
  
      try {
       
        await logout()
        // history.push("/login")
        Navigate('/login')
      } catch (e) {
        // console.log(e)
        setError("Failed to log out")
      }
    }

    const db = getFirestore(firebaseConfig)
    ChartJS.register(ArcElement, Tooltip, Legend);
    const data = {
        labels: ['ไม้แดง', 'ไม้ชิงชัง', 'ไม้เต็ง', 'ไม้พะยอม', 'ไม้พะยูง', 'ไม้มะค่าโมง'],
        datasets: [
          {
            label: '# of Votes',
            data: [12, 19, 3, 5, 2, 3],
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(255, 159, 64, 0.2)',
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
              'rgba(153, 102, 255, 1)',
              'rgba(255, 159, 64, 1)',
            ],
            borderWidth: 1,
          },
        ],
      };
    const [user, setUser] = useState([]);
    const [history, setHistory] = useState([]);
    useEffect(() => {
        const getUser = async () => {
            const data = await getDocs(collection(db, "User"));
            setUser(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        };
        const getHistory = async () => {
            const data = await getDocs(collection(db, "History"));
            setHistory(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        };
        getUser();
        getHistory();
    }, []);


    return (
        <Container>
            <div>

                 <Typography variant="h1" sx={{fontWeight:'bold', fontSize:'2.25vw', marginTop:"20px", fontFamily:'Prompt', marginBottom:"20px"}}>ยินดีต้อนรับ คุณ "Admin" 1</Typography>
                <Stack direction="row" spacing={3}>
                    <Box color="white" bgcolor="#C69B7B" p={3} sx={{
                        width: 330,
                        height: 200, borderRadius: 10, fontFamily:'Prompt'
                    }}>
                        <Stack alignItems="center" spacing={1}>
                            <h1>{user.length}</h1>
                            <h1>ผู้ใช้งาน</h1>
                        </Stack>
                    </Box>

                    <Box color="white" bgcolor="#C69B7B" p={3} sx={{
                        width: 330,
                        height: 200, borderRadius: 10, fontFamily:'Prompt'
                    }}>
                        <Stack alignItems="center" spacing={1}>
                            <h1>{history.length}</h1>
                            <h1>ประวัติในระบบ</h1>
                        </Stack>
                    </Box>

                    <Box color="white" bgcolor="#C69B7B" p={3} sx={{
                        width: 330,
                        height: 200, borderRadius: 10, fontFamily:'Prompt'
                    }}>
                        <Stack alignItems="center" spacing={1}>
                            <h1>Null</h1>
                            <h1>Dummy</h1>
                        </Stack>
                    </Box>
                    
                </Stack>
                <Container sx={{width: 1000, marginTop: 5}}>
                    <Stack direction="row" spacing={3}>
                        <div>
                    <Typography align="center" variant="h6" sx={{fontFamily:'Prompt'}}>จำนวนการตรวจสอบ</Typography>
                    <Pie data={data}/></div>
                    </Stack>
                </Container>
                
        
            </div>

        
       </Container>
    )
}
export default Dashboard